import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';

interface TableSkeletonProps {
  columns: number;
  rows?: number;
  /** Matches the real row height (48 dense / 56 comfortable). */
  rowHeight?: number;
}

/**
 * Loading rows shaped like the real ones (guide 7.5 / 8). Render it in place
 * of `<TableBody>` while data loads — never a full-screen spinner.
 */
export function TableSkeleton({
  columns,
  rows = 5,
  rowHeight = 48,
}: TableSkeletonProps): JSX.Element {
  return (
    <TableBody aria-busy="true">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableRow key={rowIndex} sx={{ height: rowHeight }}>
          {Array.from({ length: columns }).map((__, cellIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableCell key={cellIndex}>
              <Skeleton
                variant="text"
                animation="wave"
                width={cellIndex === 0 ? '60%' : '80%'}
                sx={{ fontSize: '14px' }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
